import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { useUser } from '../../../userContext';

export default function ClassificationBannerFooter() {
    const { authenticated } = useUser();
    const classificationBanner = `${process.env.REACT_APP_CLASSIFICATION_TYPE}`;
    
    return (
        <>
            { authenticated && 
                <Box component="footer" sx={{ mt: 1, minWidth:1750, backgroundColor: 'inherit' }} align="center"> 
                    <Typography 
                        variant="h6" 
                        component="h2" 
                        sx={{ 
                            fontFamily: '"Georgia", serif',
                            fontSize: '1.4rem',
                            fontWeight: 500
                        }}
                    ></Typography>
                    <Divider sx={{ width:'100%', color:'grey', borderTop: 1 }} />
                    <Typography sx={{  mt: 2, fontFamily: 'sans-serif', fontSize: '.8rem', fontWeight: 500 }}>
                        Copyright © 2015-2026, CCG, All rights reserved. This
                        material may not be reproduced, displayed, modified or
                        distributed without the express prior written permission
                        of the copyright holder.
                        <br />
                        For permission, contact sales@cancgroup.com.
                    </Typography>
                    <br />
                    <Typography 
                        variant="h6" 
                        component="h2" 
                        sx={{ 
                            fontFamily: 'sans-serif',
                            fontSize: '1.4rem',
                            fontWeight: 500
                        }}
                    >
                        Classification: <span style={{ color: 'orange' }}>{classificationBanner}</span>
                    </Typography>
                </Box>
            }
        </>
    )
}
